export default __webpack_public_path__ + "static/media/martin_vaquita.277b5df5.png";